import { Formik } from 'formik';
import * as Yup from "yup";
import React, { useState } from 'react';
import { Alert, Button, Col, Form, Input, InputGroup, Label, Row, Spinner } from 'reactstrap';
import { PostData } from '../../../services/FetchData';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";

const CollectCmsAssistant = (props) => {
	const [errorMessages, setErrorMessages] = useState("");
	const navigate = useNavigate();

	const saveStoreInformation = (values, actions) => {
		const token = Cookies.get("_cb_search_token");
		const requestData = {
			storeURL: values.websiteURL,
			openApiKey: values.openApiKey,
			storeType: "cmsassistant",
			token: token // Pass token for cms-assistant to forward to sbend
		};
		// Use ms4 for CMS Assistant API
		PostData("ms4", "api/v1/cmsAssistant/saveStore", requestData).then(result => {
			if (result !== "Invalid" && result !== undefined) {
				if (result.status === "success") {
					// Extract widget API key from response
					const widgetApiKey = result.data.widgetApiKey || "";
					
					// Navigate to messenger settings page with website data and API key
					navigate("/getStarted/cmsAssistantSettings", { 
						state: { 
							websiteId: result.data.websiteId,
							websiteURL: values.websiteURL,
							widgetApiKey: widgetApiKey
						},
						replace: true 
					});
				} else {
					setErrorMessages(result.message || "An error occurred")
				}
			}
			actions.setSubmitting(false)
		}).catch(error => {
			setErrorMessages("An error occurred. Please try again.")
			actions.setSubmitting(false)
		})
	}

	return (
		<>
			<section className='choosePlatformHeader'>
				<div className='container'>
					<Row className="align-items-center justify-content-center">
						<Col xs={"auto"}>
							<h2 className='mt-5'>CMS Assistant Setup</h2>
							<p className='text-center text-muted'>Step 1 of 2: Enter your website information</p>
						</Col>
					</Row>
				</div>
			</section>
			<section className='shopifyAppInstallationGuide mt-5'>
				<div className='container'>
					<Row className='align-items-center justify-content-center'>
						<Col xs={12} lg={6} className='text-center d-none d-lg-block'>
							<img src={require("./../../../assets/images/integration.png")} alt="integration" className='img-fluid' />
						</Col>
						<Col xs={12} lg={6}>
							{errorMessages !== "" && (
								<Alert color="danger">
									{errorMessages}
								</Alert>
							)}
							<div className='storeInformationWrapper'>
								<Formik
									initialValues={{ websiteURL: "", openApiKey: "" }}
									onSubmit={(values, actions) => {
										saveStoreInformation(values, actions)
									}}
									validationSchema={Yup.object().shape({
										openApiKey: Yup.string().required("Open AI API key is required"),
										websiteURL: Yup.string().required("Website URL is required").url("Please enter a valid website URL")
									})}
								>
									{props => {
										const {
											values,
											touched,
											errors,
											isSubmitting,
											handleChange,
											handleBlur,
											handleSubmit
										} = props;
										return (
											<Form role="form" onSubmit={handleSubmit} noValidate>
												<div className={`position-relative mb-5 ${(errors.openApiKey && touched.openApiKey && "error_field")}`}>
													<Label className="input-group-alternative-label" >
														Open AI API Key
													</Label>
													<InputGroup className="input-group-alternative">
														<Input
															placeholder="sk-..."
															type={"text"}
															name="openApiKey"
															value={values.openApiKey}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																"col" ||
																(errors.openApiKey && touched.openApiKey && "error")
															}
															autoFill="false"
														/>
													</InputGroup>
													{errors.openApiKey && touched.openApiKey && (
														<div className="input-feedback">{errors.openApiKey}</div>
													)}
												</div>
												<div className={`position-relative mb-5 ${(errors.websiteURL && touched.websiteURL && "error_field")}`}>
													<Label className="input-group-alternative-label" >
														Website URL
													</Label>
													<InputGroup className="input-group-alternative">
														<Input
															placeholder="https://example.com"
															type={"text"}
															name="websiteURL"
															value={values.websiteURL}
															onChange={handleChange}
															onBlur={handleBlur}
															className={
																"col" ||
																(errors.websiteURL && touched.websiteURL && "error")
															}
															autoFill="false"
														/>
													</InputGroup>
													{errors.websiteURL && touched.websiteURL && (
														<div className="input-feedback">{errors.websiteURL}</div>
													)}
												</div>
												<div className="d-flex justify-content-center">
													{isSubmitting ? (
														<Button className="cta authCta" color="primary" type="button" disabled>
															<Spinner
																className="white mr-1"
																size="sm"
																color="light"
															/>
															<span className="ml-2 d-inline-block">Loading</span>
														</Button>
													) : (
														<Button className="cta authCta" color="primary" type="submit">
															Next: Configure Messenger
														</Button>
													)}
												</div>
											</Form>)
									}}
								</Formik>
							</div>
						</Col>
					</Row>
				</div>
			</section>
		</>
	);
}

export default CollectCmsAssistant;
